module.exports = __webpack_public_path__ + "static/media/353.ff899ed6.webp";